import Vue from 'vue'
import App from './App.vue'
import Home from './components/Home.vue'
import BakingIngredients from './components/BakingIngredients.vue'
import AboutUs from './components/AboutUs.vue'
import ContactUs from './components/ContactUs.vue'
import New from './components/New.vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
 routes: [
   {
    path: '/',
    component: Home
   },
   {
     path: '/aboutUs',
     component: AboutUs
   },
   {
    path: '/BakingIngredients',
    component: BakingIngredients
   },
   {
    path: '/ContactUs',
    component: ContactUs
  
   },
   {
    path: '/New',
    component: New
  
   }
 ], 
 mode: 'history'

})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

